import axiosInstance from '../main/axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import configLocal from '../configuracao/configLocal';
import userLocal from '../configuracao/userLocal';

const INITIAL_VALUES = {};
const STORAGE_KEY = 'ssat_notifications';

// Função para salvar notificações no localStorage
export function saveNotificationsToLocalStorage(notifications) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
  } catch (error) {
    console.error('Erro ao salvar notificações no localStorage:', error);
  }
}

// Função para carregar notificações do localStorage
export function loadNotificationsFromLocalStorage() {
  try {
    const storedNotifications = localStorage.getItem(STORAGE_KEY);
    return storedNotifications ? JSON.parse(storedNotifications) : [];
  } catch (error) {
    console.error('Erro ao carregar notificações do localStorage:', error);
    return [];
  }
}

// Sincroniza o estado com as notificações do localStorage
export function syncNotificationsFromLocalStorage() {
  const notifications = loadNotificationsFromLocalStorage();
  // Aplicar ordenação nas notificações do localStorage
  const notificationsOrdenadas = Array.isArray(notifications)
    ? notifications.sort((a, b) => {
        if (a.grupo_fisico_id !== b.grupo_fisico_id) {
          return a.grupo_fisico_id - b.grupo_fisico_id;
        }
        if (a.numero_controlador !== b.numero_controlador) {
          return a.numero_controlador - b.numero_controlador;
        }
        // Se mesmo grupo e controlador, ordenar por data/hora desc
        const dateA = new Date(`${a.data_erro} ${a.hora_erro}`);
        const dateB = new Date(`${b.data_erro} ${b.hora_erro}`);
        return dateB - dateA;
      })
    : [];

  return {
    type: 'CONTROLADOR_ERRO_SYNC_LOCAL_STORAGE',
    payload: notificationsOrdenadas,
  };
}

export const setListLoading = loading => ({
  type: 'CONTROLADOR_ERRO_LIST_LOADING',
  payload: loading,
});

export function getList() {
  var grupoId = configLocal.getConfig('grupo');
  var numCont = configLocal.getConfig('numCont');

  // Buscar todos os erros do controlador específico (sem agrupar)
  const request = axiosInstance.get(`/controladoreserro/${grupoId}/${numCont}`, {
    params: { email: userLocal.getUserConfig('email') },
  });

  return {
    type: 'CONTROLADOR_ERRO_DETALHES_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'ERRO_PAGE',
  payload: pagina,
});

export function addNewError(erro) {
  // Adicionar ao estado com ordenação e deduplicação
  const action = {
    type: 'CONTROLADOR_ERRO_ADDED',
    payload: erro,
  };

  // Atualizar localStorage
  setTimeout(() => {
    const currentState = window.store.getState().controladorErroCad.list || [];
    // Aplicar ordenação por grupo físico + controlador
    const sortedState = [...currentState].sort((a, b) => {
      if (a.grupo_fisico_id !== b.grupo_fisico_id) {
        return a.grupo_fisico_id - b.grupo_fisico_id;
      }
      if (a.numero_controlador !== b.numero_controlador) {
        return a.numero_controlador - b.numero_controlador;
      }
      // Se mesmo grupo e controlador, ordenar por data/hora desc
      const dateA = new Date(`${a.data_erro} ${a.hora_erro}`);
      const dateB = new Date(`${b.data_erro} ${b.hora_erro}`);
      return dateB - dateA;
    });
    saveNotificationsToLocalStorage(sortedState);
  }, 100);

  return action;
}

export function getAlertaErro() {
  // var contId = configLocal.getConfig('cont');
  const email = userLocal.getUserConfig('email');

  const request = axiosInstance.get(`/controladoreserro/${email}`);

  return {
    type: '',
    payload: request,
  };
}

export function clearAlertaErro(alerts) {
  const email = userLocal.getUserConfig('email');
  const request = axiosInstance.put(`/controladoreserro`, { alerts: alerts, email });

  return {
    type: '',
    payload: request,
  };
}

export function getRemoteList() {
  const contId = configLocal.getConfig('cont');
  const numCont = configLocal.getConfig('numCont');

  const request = axiosInstance.get(`/controladoreserro/remote/${contId}/${numCont}`, {
    params: { email: userLocal.getUserConfig('email') },
  });

  return {
    type: '',
    payload: request,
  };
}

export function init() {
  INITIAL_VALUES.controlador_id = configLocal.getConfig('cont');
  return [showTabs('tabList'), selectTab('tabList')];
}
